<div modalHeader class="modal-header">
  <ng-container *ngIf="user; else loading">
    <div class="d-flex justify-content-between w-100 align-items-center">
      <div class="d-flex">
        <a class="d-flex flex-row align-items-center text-decoration-none" *ngIf="openedFromAdminPanel" (click)="close()">
          <tr-icon [icon]="icon.arrowBack"></tr-icon>

          <div class="d-flex flex-column ml-3">
            <p class="title-account font-weight-bold m-0">Account: {{ accountName }}</p>

            <div class="d-flex align-items-center">
              <p class="title-user pb-0 mb-0 mr-2" id="exampleModalLabel">User: {{ user.name || 'User' }}</p>
              <info-badge *ngIf="isAdmin" class="mt-1" label="ADMIN"></info-badge>
            </div>
          </div>
        </a>
      </div>

      <tr-icon [icon]="icon.cancel" class="close-btn" (click)="closeAll()"></tr-icon>
    </div>
  </ng-container>
</div>

<div modalContent #contentDivRef class="modal-body">
  <ng-container *ngIf="user; else loading">
    <div class="top-content" #topContent>
      <div class="alert alert-info d-flex flex-row justify-content-between" role="alert">
        <span class="text-black">Administrator access</span>
        <input
          type="checkbox"
          #adminAccessCheckbox
          [checked]="isAdmin"
          (change)="changeAccountRole(adminAccessCheckbox)"
        >
      </div>

      <p *ngIf="!user.locationUsers.length && !isAdmin">No assigned locations.</p>
      <p *ngIf="isAdmin">Account administrators have access to <a (click)="navigateToLocationsPage()">all locations</a>.</p>

      <div
        *ngIf="!isAdmin"
        class="search-bar-line"
        [class.justify-content-center]="user.locationUsers.length === 0">
        <tablesready-search-bar
          *ngIf="user.locationUsers.length > 0"
          placeholder="Search locations"
          btnColorClass="btn-light"
          [whiteIconColorEnabled]="false"
          (search)="filterLocations($event)"
        ></tablesready-search-bar>

        <button class="btn btn-info assign-btn" (click)="assignLocations()">+ Assign location</button>
      </div>
    </div>

    <div *ngIf="user.locationUsers.length > 0 && !isAdmin" class="location-list">
      <ng-container *ngIf="locationsToDisplay.length > 0; else noLocations">
        <div class="location-list__item background-hover" *ngFor="let locationUser of locationsToDisplay">
          <a
            class="location-list__item-name"
            [class.disabled]="!locationUser.locationEnabled"
            [ngbTooltip]="'See location users list'"
            [innerText]="locationUser.locationName"
            (click)="navigateToLocationWaitlist(locationUser.locationId)"
          ></a>

          <div class="location-list__item-actions">
            <div class="btn-group" role="group" aria-label="Radio Buttons with Bootstrap 5">
              <ng-container *ngFor="let role of userRoles">
                <input
                  #roleCheckbox
                  [id]="locationUser.locationId + role.value"
                  type="checkbox"
                  [value]="role.value"
                  [ngModel]="userLocationsMap[locationUser.locationId].role"
                  (ngModelChange)="updateUserRole(locationUser, roleCheckbox.value)"
                  class="btn-check checked"
                  autocomplete="off"
                />
                <label
                  class="btn mb-0"
                  [class.btn-success]="userLocationsMap[locationUser.locationId].role === role.value"
                  [class.btn-outline-success]="userLocationsMap[locationUser.locationId].role !== role.value"
                  [for]="locationUser.locationId + role.value"
                  [innerText]="role.name"
                ></label>
              </ng-container>
            </div>

            <button class="btn btn-danger ml-2 px-2" [ngbTooltip]="'Remove from location'" (click)="removeFromLocation(locationUser)">Remove</button>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<div modalFooter class="modal-footer">
  <button type="button" class="btn btn-info-outline" (click)="closeAll()">Close</button>
</div>


<ng-template #loading>
  <h3>Loading data...</h3>
</ng-template>

<ng-template #noLocations>
  <h6 class="text-center">No locations found</h6>
</ng-template>
